import {
    SortingDirection as SortingDirectionFromHelpers,
    SortingParams as SortingParamsFromHelpers,
} from '../../../MyStichtingOpenHelpers/src/static'

/**
 * @deprecated use import from Helpers
 * @todo Remove this type after all references are updated
*/
export type SortingParams = SortingParamsFromHelpers
export interface Sorting extends SortingParamsFromHelpers { }
/**
 * @deprecated use import from Helpers
 * @todo Remove this type after all references are updated
*/
export { SortingDirectionFromHelpers as SortingDirection }

export type SortingURLParams = {
    OrderBy: string
}

export type UseSortingModel = {
    sorting: Sorting
    sortHandler: (sortBy: string) => void
}
